<template>
  <div
    class="LayoutSelection-menu"
  >
    <ul>
      <li
        :class="{ Selected: questionLayoutType === 'text-only' }"
        @click="setScreenLayoutType('text-only')"
      >
        <div class="LayoutSkeleton">
          <span class="TextBar" />
          <span class="TextBar-short" />
          <span class="ButtonBar" />
        </div>
      </li>
      <li
        :class="{ Selected: questionLayoutType === 'media-middle' }"
        @click="setScreenLayoutType('media-middle')"
      >
        <div class="LayoutSkeleton">
          <span class="TextBar" />
          <span class="MediaBar-short" />
          <span class="TextBar-short" />
          <span class="ButtonBar" />
        </div>
      </li>
      <li
        :class="{ Selected: questionLayoutType === 'image-left' }"
        @click="setScreenLayoutType('image-left')"
      >
        <div class="LayoutSkeleton u-flex u-flex-alignCenter Media-left">
          <span class="MediaBar" />
          <div>
            <span class="TextBar" />
            <span class="TextBar-short" />
            <span class="ButtonBar" />
          </div>
        </div>
      </li>
      <li
        :class="{ Selected: questionLayoutType === 'image-right' }"
        @click="setScreenLayoutType('image-right')"
      >
        <div class="LayoutSkeleton u-flex u-flex-alignCenter Media-right">
          <div>
            <span class="TextBar" />
            <span class="TextBar-short" />
            <span class="ButtonBar" />
          </div>
          <span class="MediaBar" />
        </div>
      </li>
      <li
        :class="{ Selected: questionLayoutType === 'background-image' }"
        @click="setScreenLayoutType('background-image')"
      >
        <div class="LayoutSkeleton Media-Background">
          <span class="TextBar" />
          <span class="TextBar-short" />
          <span class="ButtonBar" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ScreenLayoutMenu',

  props: {
    questionLayoutType: {
      type: String,
      default: null,
    },
  },

  methods: {
    setScreenLayoutType(layoutType) {
      this.$emit('screen-layout-menu:set-layout-type', layoutType);
    },
  },
};
</script>

<style scoped lang="scss">
.LayoutSelection-menu {
  position: absolute;
  width: 184px;
  padding: 7px 10px;
  border-radius: 6px;
  max-height: 400px;
  background: white;
  border: 1px solid lightgrey;
  z-index: 5;
  top: 30px;

  .Selected {
    border-color: #046ff0;
  }

  ul {
    display: flex;
    flex-wrap: wrap;
    margin: 0;
  }
  li {
    border: 1px solid lightgray;
    border-radius: 4px;
    text-align: center;
    margin: 5px 8px 5px 0;
    cursor: pointer;

    &:hover {
      &:not(.Selected) {
        border: 1px solid #b8b8b8;
      }
    }
  }

  .LayoutSkeleton {
    width: 70px;
    height: 38px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 17px;

    &.Media-left,
    &.Media-right {
      flex-direction: row;
      padding-left: 0;
    }

    &.Media-left {
      padding-left: 3px;
      justify-content: flex-start;
      .MediaBar {
        margin: 0 2px 0 0;
      }
    }
    &.Media-right {
      padding-right: 3px;
      justify-content: flex-end;
      .MediaBar {
        margin: 0 0 0 2px;
      }
    }

    &.Media-Background {
      background-color: #d0d7e1;
      border-radius: 3px;

      .TextBar,
      .TextBar-short,
      .ButtonBar {
        background: white;
      }
    }

    span {
      display: block;
      margin-bottom: 3px;
    }
    .TextBar {
      background: #d0d7e1;
      width: 36px;
      height: 2px;
    }
    .TextBar-short {
      background: #d0d7e1;
      width: 17px;
      height: 2px;
    }
    .MediaBar {
      background: #d0d7e1;
      width: 19px;
      height: 30px;
    }
    .MediaBar-short {
      background: #d0d7e1;
      width: 36px;
      height: 10px;
    }
    .ButtonBar {
      width: 5px;
      height: 3px;
      background: #d0d7e1;
      border-radius: 4px;
    }
  }
}
</style>
